import { forwardRef, type SelectHTMLAttributes } from "react";
import { cn } from "../../lib/cn";

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      className={cn(
        "h-11 w-full rounded-md border border-border bg-surface px-3 text-[16px] text-text",
        "focus:outline-none focus:ring-2 focus:ring-[var(--focus-ring)] focus:border-primary",
        "disabled:bg-surface-2 disabled:cursor-not-allowed",
        className,
      )}
      {...rest}
    />
  );
});
